import { styled } from './utils/styled';
import styles from './Typography.css';

/**
 * D1
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const D1 = styled('span', {
  class: styles['display-1'],
  name: 'D1',
  description:
    'Display 01 typography style. This component passes all HTML attributes for a "span".'
});

/**
 * D2
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const D2 = styled('span', {
  class: styles['display-2'],
  name: 'D2',
  description:
    'Display 02 typography style. This component passes all HTML attributes for a "span".'
});

/**
 * D3
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const D3 = styled('span', {
  class: styles['display-3'],
  name: 'D3',
  description:
    'Display 03 typography style. This component passes all HTML attributes for a "span".'
});

/**
 * D4
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const D4 = styled('span', {
  class: styles['display-4'],
  name: 'D4',
  description:
    'Display 04 typography style. This component passes all HTML attributes for a "span".'
});

/**
 * H1
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H1 = styled('h1', {
  class: styles['headline-1'],
  name: 'H1',
  description:
    'Headline 01 typography style. This component passes all HTML attributes for a "h1".'
});

/**
 * H2
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H2 = styled('h2', {
  class: styles['headline-2'],
  name: 'H2',
  description:
    'Headline 02 typography style. This component passes all HTML attributes for a "h2".'
});

/**
 * H3
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H3 = styled('h3', {
  class: styles['headline-3'],
  name: 'H3',
  description:
    'Headline 03 typography style. This component passes all HTML attributes for a "h3".'
});

/**
 * H4H
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H4 = styled('h4', {
  class: styles['headline-4'],
  name: 'H4',
  description:
    'Headline 04 typography style. This component passes all HTML attributes for a "h4".'
});

/**
 * H5
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H5 = styled('h5', {
  class: styles['headline-5'],
  name: 'H5',
  description:
    'Headline 05 typography style. This component passes all HTML attributes for a "h5".'
});

/**
 * H6
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H6 = styled('h6', {
  class: styles['headline-6'],
  name: 'H6',
  description:
    'Headline 06 typography style. This component passes all HTML attributes for a "h6".'
});

/**
 * B1
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const B1 = styled('span', {
  class: styles['body-1'],
  name: 'B1',
  description:
    'Body 01 typography style. This component passes all HTML attributes for a "span".'
});

/**
 * B2
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const B2 = styled('span', {
  class: styles['body-2'],
  name: 'B2',
  description:
    'Body 02 typography style. This component passes all HTML attributes for a "span".'
});

/**
 * B3
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const B3 = styled('span', {
  class: styles['body-3'],
  name: 'B3',
  description:
    'Body 03 typography style. This component passes all HTML attributes for a "span".'
});

/**
 * B4
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const B4 = styled('span', {
  class: styles['body-4'],
  name: 'B4',
  description:
    'Body 04 typography style. This component passes all HTML attributes for a "span".'
});

/**
 * Thin
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Thin = styled('span', {
  class: styles['avenir-thin'],
  name: 'Thin',
  description: 'Avenir Font with Thin weight applied.'
});

/**
 * Regular
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Regular = styled('span', {
  class: styles['avenir-regular'],
  name: 'Regular',
  description: 'Avenir Font with Regular weight applied.'
});

/**
 * Medium
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Medium = styled('strong', {
  class: styles['avenir-medium'],
  name: 'Medium',
  description: 'Avenir Font with Medium weight applied.'
});

/**
 * Demi
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Demi = styled('strong', {
  class: styles['avenir-demi'],
  name: 'Demi',
  description: 'Avenir Font with Demi weight applied.'
});

/**
 * Bold
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Bold = styled('strong', {
  class: styles['avenir-bold'],
  name: 'Bold',
  description: 'Avenir Font with Bold weight applied.'
});

/**
 * Heavy
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Heavy = styled('strong', {
  class: styles['avenir-heavy'],
  name: 'Heavy',
  description: 'Avenir Font with Heavy weight applied.'
});
